<template>
  <el-dialog title="转发" :visible.sync="visible" width="600px" :before-close="onClose">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="好友" name="friend">
        <el-input v-model="keyword" placeholder="搜索好友" size="small" style="margin-bottom:8px" />
        <el-scrollbar style="height:340px">
          <div v-for="f in filteredFriends" :key="f.id" class="fd-item" @click="selectTarget('PRIVATE', f)">
            <head-image :url="f.headImageThumb" :name="f.nickName" :size="32" />
            <span class="fd-name">{{ f.remarkName || f.nickName }}</span>
          </div>
        </el-scrollbar>
      </el-tab-pane>
      <el-tab-pane label="群聊" name="group">
        <el-input v-model="keyword" placeholder="搜索群" size="small" style="margin-bottom:8px" />
        <el-scrollbar style="height:340px">
          <div v-for="g in filteredGroups" :key="g.id" class="fd-item" @click="selectTarget('GROUP', g)">
            <head-image :url="g.headImageThumb" :name="g.showGroupName" :size="32" />
            <span class="fd-name">{{ g.showGroupName }}</span>
          </div>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "forwardDialog",
  components: { HeadImage },
  props: {
    // 需要在列表中排除的用户id集合（如：当前用户、本次被推荐的名片用户等）
    excludeIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      activeTab: "friend",
      keyword: "",
    };
  },
  computed: {
    friends() {
      return this.$store.state.friendStore.friends || [];
    },
    groups() {
      return this.$store.state.groupStore.groups || [];
    },
    filteredFriends() {
      const k = this.keyword.trim();
      // 去重：按 id 构建 Map
      const idToFriend = new Map();
      (this.friends || []).forEach((f) => {
        if (f && f.id != null && !idToFriend.has(f.id)) {
          idToFriend.set(f.id, f);
        }
      });
      // 过滤：排除自己与传入的排除项
      const selfId = this.$store.state.userStore.userInfo?.id;
      const exclude = new Set([selfId, ...(this.excludeIds || [])]);
      const uniq = Array.from(idToFriend.values()).filter((f) => !exclude.has(f.id));
      return uniq.filter((f) => !k || (f.remarkName || f.nickName || "").includes(k));
    },
    filteredGroups() {
      const k = this.keyword.trim();
      // 去重群：按 id 去重
      const idToGroup = new Map();
      (this.groups || []).forEach((g) => {
        if (g && g.id != null && !idToGroup.has(g.id)) {
          idToGroup.set(g.id, g);
        }
      });
      const uniq = Array.from(idToGroup.values());
      return uniq.filter((g) => !k || (g.showGroupName || "").includes(k));
    },
  },
  methods: {
    open() {
      this.keyword = "";
      this.activeTab = "friend";
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    selectTarget(type, item) {
      const target =
        type === "GROUP"
          ? { type: "GROUP", targetId: item.id, showName: item.showGroupName }
          : { type: "PRIVATE", targetId: item.id, showName: item.remarkName || item.nickName };
      this.$emit("confirm", target);
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.fd-item {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  cursor: pointer;
  border-radius: 6px;
}
.fd-item:hover {
  background: var(--im-background-active);
}
.fd-name {
  margin-left: 8px;
}
</style>


